

import React, { useState, useEffect } from 'react';
import Header from '../../Layout/Header';
import Sidebar from '../../Layout/Sidebar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import TotalPlayers from './Total_players';
import { useNavigate } from 'react-router-dom';
import { SERVER_URL } from '../../../config';

export default function Dashboard() {
  const [recentProfiles, setRecentProfiles] = useState([]);
  const [recentActivities, setRecentActivities] = useState([]);
  const [activePercentage, setActivePercentage] = useState(0);
  const [inactivePercentage, setInactivePercentage] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [activeCount, setActiveCount] = useState(0);
  const [chartSeries, setChartSeries] = useState([0]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = sessionStorage.getItem('admin_token');
        if (!token) {
          setError('No admin token found');
          setLoading(false);
          return;
        }

        const dashboardResponse = await fetch(`${SERVER_URL}/api/admin/dashboard`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        const dashboardData = await dashboardResponse.json();

        const usersResponse = await fetch(`${SERVER_URL}/api/admin/user/active-users`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        const usersData = await usersResponse.json();

        if (dashboardData.status && usersData.status) {
          setRecentProfiles(dashboardData.recent_profiles || []);
          setRecentActivities(dashboardData.recent_activities || []);
          const total = usersData.total_users || 0;
          const active = usersData.active_count || 0;
          setTotalUsers(total);
          setActiveCount(active);
          setActivePercentage(total > 0 ? ((active / total) * 100).toFixed(1) : 0);
          setInactivePercentage(total > 0 ? ((total - active) / total * 100).toFixed(1) : 0);
          const percentage = total > 0 ? ((active / total) * 100).toFixed(1) : 0;
          setChartSeries([parseFloat(percentage)]);
        } else {
          setError(dashboardData.msg || usersData.msg || 'Failed to fetch data');
        }
      } catch (err) {
        setError('Failed to fetch dashboard data');
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  const handleManageProfiles = () => {
    navigate('/admin/user');
  };

  return (
    <div className='min-h-screen lg:h-screen flex flex-col bg-cover bg-no-repeat text-white' style={{ backgroundImage: 'url("/assets/bg/adminbg.svg")' }}>
      <Header />
      <div className='flex flex-col lg:flex-row flex-grow overflow-hidden'>
        <Sidebar />
        <div className='lg:w-[80%] overflow-y-auto p-5'>
          <div className='flex flex-col lg:flex-row gap-10'>
            <div className='w-full lg:w-[60%]'>
              <div className='bg-white/10 rounded-xl flex items-center justify-center pl-10 py-5 pr-0'>
                <div className='w-[100%] lg:w-[75%]'>
                  <p className='text-2xl font-bold'>Create and Transfer DNA to the Player Profiles</p>
                  <p className='mt-3 text-sm 2xl:text-base'>The worid's first Lab Report as Players DNA Analaysis.</p>
                  <button className='border rounded-full p-[1px] w-[211px] mt-5 overflow-hidden'>
                    <div className='-translate-x-9 hover:translate-x-0 duration-500 flex items-center cursor-pointer'>
                      <button className='w-8 h-8 px-3 bg-white rounded-full grid place-content-center mr-4'><FontAwesomeIcon icon={faArrowRight} className='text-black' /></button>
                      <span className='text-nowrap'>Create Player Profile</span>
                      <button className='w-8 h-8 px-3 bg-white rounded-full grid place-content-center ml-4'><FontAwesomeIcon icon={faArrowRight} className='text-black' /></button>
                    </div>
                  </button>
                </div>
                <img src='/assets/others/soccer-ball.svg' className='w-[25%] mx-auto'></img>
              </div>
              <div>
                <div className='mt-4 flex items-center justify-between'>
                  <p className='font-bold text-xl'>Recent Profiles</p>
                  <p className='cursor-pointer' onClick={handleManageProfiles}>Manage Profiles</p>
                </div>
                <div className={`mt-3 ${recentProfiles.length > 0 ? 'grid grid-cols-3 gap-5' : ''}`}>
                  {loading ? (
                    <div className='text-center py-16 bg-white/10 rounded-xl'>Loading...</div>
                  ) : error ? (
                    <div className='text-center py-16 bg-white/10 rounded-xl'>{error}</div>
                  ) : recentProfiles.length > 0 ? (
                    recentProfiles.map((item, index) => (
                      <div key={index} className='bg-white/10 rounded-xl text-center pt-3 px-3 grid content-between'>
                        <p className='text-sm'>{item.profile_id}</p>
                        <p className='leading-5 mt-1'>{item.profile_name}</p>
                        <img src={item.profile_photo} className='w-40 2xl:w-auto mx-auto'></img>
                      </div>
                    ))
                  ) : (
                    <div className='text-center py-16 bg-white/10 rounded-xl'>No data</div>
                  )}
                </div>
              </div>
              <div className='bg-white/10 rounded-xl px-10 py-3 mt-5'>
                <div className='flex items-center justify-between mb-2'>
                  <p className='font-bold text-xl'>Recent Activity</p>
                  <p>View more</p>
                </div>
                <div className='flex flex-col gap-3 2xl:gap-5'>
                  {loading ? (
                    <div className='text-center py-5'>Loading...</div>
                  ) : error ? (
                    <div className='text-center py-5'>{error}</div>
                  ) : recentActivities.length > 0 ? (
                    recentActivities.map((item, index) => (
                      <div key={index} className='flex items-center justify-between'>
                        <div className='flex gap-3 items-center'>
                          <div>
                            <img src={item.activity_photo} className='w-10 h-10 rounded-full'></img>
                          </div>
                          <div>
                            <p className='text-xs 2xl:text-sm'>{item.activity_name_id}</p>
                            <p className='text-sm 2xl:text-base'>{item.activity_message}</p>
                          </div>
                        </div>
                        <p className='text-sm'>{item.time}</p>
                      </div>
                    ))
                  ) : (
                    <div className='text-center py-5'>No data</div>
                  )}
                </div>
              </div>
            </div>
            <div className='w-full lg:w-[40%] grid content-between gap-5'>
              <div className='bg-white/10 rounded-xl p-5'>
                <p className='text-xl font-bold'>Player Profiles</p>
                <TotalPlayers totalUsers={totalUsers} chartSeries={chartSeries} loading={loading} error={error} />
                <div className='flex items-center justify-between'>
                  <p className='flex items-center gap-2 font-bold'>
                    <div className='w-2 h-2 rounded bg-green-500'></div>
                    Active +{activePercentage}%
                  </p>
                  <p className='flex items-center gap-2 font-bold'>
                    <div className='w-2 h-2 rounded bg-red-500'></div>
                    Inactive -{inactivePercentage}%
                  </p>
                </div>
              </div>
              <div className='bg-white/10 rounded-xl text-center py-10'>
                <p className='text-3xl font-bold'>11</p>
                <p className='text-xl font-bold mt-3'>Transferred DNA Reports</p>
              </div>
              <div className='bg-white/10 rounded-xl text-center py-10'>
                <p className='text-3xl font-bold'>0</p>
                <p className='text-xl font-bold mt-3'>Pending DNA Reports</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}